import {YandexMapService} from 'modules/yandex-map/services/YandexMapService';
import {createContext} from 'react';

export interface IYandexMapContext {
    service?: YandexMapService;
    ready?: boolean;
}

export const YandexMapContext = createContext<IYandexMapContext>({});
